import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs/operators';
import { StoreService } from '@morningstar/shared/base/base-service';
import { HttpParamsHelper } from '@morningstar/shared/util';
import { environment } from '@morningstar/shared/environment';
import { RevenueTotalDatum } from './revenue-total-datum';
import { RevenueTotalOptions } from './revenue-total-options';

@Injectable()
export class RevenueTotalService extends StoreService {

  constructor(protected httpClient: HttpClient,
              @Inject('API_BASE_URL') private baseHref,
              snackbar: MatSnackBar) {
    super(httpClient, baseHref, snackbar);
  }

  getCategoryTrendLine(location: string, category: string, options: RevenueTotalOptions) {
    const params = new HttpParams({
      fromObject: HttpParamsHelper.mapToQueryParams(options)
    });

    return this.httpClient.get<RevenueTotalDatum[]>(this.baseHref + environment.api.dashboard.categoryTrend.line
                                                      .replace('{location}', location)
                                                      .replace('{category}', category), {
                                                      params: params
                                                    });
  }
}
